import React, { useState, useEffect, useRef } from 'react';

const AutoCompleteInput = ({ data, value = "", onChange, onSelect, placeholder, validationLabel = "", disabled = false, maxHeight = 300, name = "" }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const inputRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Filtre les suggestions en fonction de la saisie
  useEffect(() => {
    if (value.length >= 3) {
      const filteredSuggestions = data.filter((item) =>
        item.searchValue.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  }, [value, data])


  // Gère la navigation au clavier
  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setActiveIndex((prevIndex) => Math.min(prevIndex + 1, suggestions.length - 1));
    } else if (e.key === 'ArrowUp') {
      setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      const selectedItem = suggestions[activeIndex];
      if (selectedItem) {
        handleSelect(selectedItem);
      }
    }
  };

  // Gère la sélection d'une suggestion
  const handleSelect = (selectedItem) => {
    inputRef.current.blur();
    onSelect(selectedItem); // Appelle la fonction onSelect avec l'ID de l'élément sélectionné
    setActiveIndex(-1); // Réinitialise l'index actif

  };

  const handleChange = (e) => {
    setVisible(true);
    onChange(e);
  }

  const handleBlur = () => {
    setVisible(false);
  }

  const nonValidStyle = {
    backgroundColor: "#dc35454d",
    borderBottom: "1px solid #dc3545"
  }

  const disabledStyle = {
    backgroundColor: "lightgray",
    color: "gray"
  }

  return (
    <div className="relative w-full z-30">
      <input
        name={name}
        ref={inputRef}
        type="text"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onFocus={()=>setVisible(true)}
        className="min-h-10 placeholder:text-gray outline-none border-b border-[#504343] w-full bg-[#f5f5f5] px-2 text-md focus:bg-[#ebebeb]"
        placeholder={placeholder}
        autoComplete="new-password"
        style={disabled ? disabledStyle : (validationLabel ? nonValidStyle : {})}
      />
      <p className="absolute top-0 right-1 text-red text-xs" >{validationLabel}</p>
      {(suggestions.length > 0 && visible) && (
        <ul style={{ maxHeight: maxHeight }} className="absolute left-0 right-0 bg-white border border-light-gray shadow-lg z-10 overflow-y-auto overflow-x-hidden cursor-pointer" onMouseDown={(e) => e.preventDefault()} >
          {suggestions.map((item, index) => (
            <li
              key={item.id}
              className={`px-2 py-1 hover:bg-light-gray text-sm ${index === activeIndex ? 'bg-light-gray' : ''
                }`}
              onClick={() => handleSelect(item)} // Sélectionne l'élément au clic
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteInput;